import React from 'react';
import SignUp from "./sign-up/SignUp";

function Register({queryParams}) {
    return (
        <SignUp queryParams={queryParams}/>
    );
}

export default Register;
